import { useSelector } from "@/store";

export function useAuthentication() {
  return useSelector((state) => state.authentication);
}
